import React from "react";
import QuadrataShowSingleItem from "./QuadrataShowSingleItem";
import QuadrataShowMultipleItems from "./QuadrataShowMultipleItems";
import useHistoricalShares from "../../hooks/useHistoricalShares";
import { useFormatSetting } from "../../hooks/useCompanySettings";

const QuadrataViewHistory = ({ onClose }) => {
  const {
    historicalShares: { historicalShareList },
  } = useHistoricalShares();
  const formatSettings = useFormatSetting();
  const firstHistoricalShare = historicalShareList?.[0] || {};

  return (
    <div className="animationAppear">
      {historicalShareList?.length > 1 ? (
        <QuadrataShowMultipleItems historicalShare={historicalShareList} formatSettings={formatSettings} onClose={onClose}/>
      ) : (
        <QuadrataShowSingleItem historicalShare={firstHistoricalShare} formatSettings={formatSettings} onClose={onClose}/>
      )}
    </div>
  );
};

export default QuadrataViewHistory;
